// extracted by mini-css-extract-plugin
export var button = "Button-module--button--45b1e";
export var calendarIcon = "Button-module--calendarIcon--bcc9b";
export var oldDesign = "Button-module--oldDesign--5b561";
export var outlined = "Button-module--outlined--d2879";
export var secondary = "Button-module--secondary--d05b6";
export var withWhatsappColor = "Button-module--withWhatsappColor--324a2";